/* Stargazer Nikki theme scripts: header, services, testimonials, gallery. */
(function(){
  "use strict";
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var VS = '︎';
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}

  /* Header */
  var header=$('.sg-header');
  if(header){
    var onScroll=function(){header.classList.toggle('is-scrolled',window.scrollY>10)};
    window.addEventListener('scroll',onScroll,{passive:true});onScroll();
    var openB=$('.sg-menu-btn--open'),closeB=$('.sg-menu-btn--close');
    if(openB&&closeB){
      var clearHash=function(){if(/^#(SgMobileMenu|sg-menu-closed)$/.test(location.hash))history.replaceState(null,'',location.pathname+location.search)};
      var setOpen=function(o){header.classList.toggle('is-open',o);openB.setAttribute('aria-expanded',String(o));if(!o)clearHash()};
      openB.addEventListener('click',function(e){e.preventDefault();setOpen(true)});
      closeB.addEventListener('click',function(e){e.preventDefault();setOpen(false)});
      $$('.sg-mobile a').forEach(function(a){a.addEventListener('click',function(){setOpen(false)})});
      document.addEventListener('keydown',function(e){if(e.key==='Escape')setOpen(false)});
      document.addEventListener('click',function(e){if(header.classList.contains('is-open')&&!e.target.closest('.sg-header'))setOpen(false)});
      if(location.hash==='#SgMobileMenu')setOpen(true);
    }
  }

  function boot(){
  /* Services: expand details */
  $$('.sg-svc__more:not([data-ready])').forEach(function(b){b.setAttribute('data-ready','');
    b.addEventListener('click',function(){var d=document.getElementById(b.getAttribute('aria-controls'));var o=b.getAttribute('aria-expanded')!=='true';b.setAttribute('aria-expanded',String(o));d.hidden=!o;b.querySelector('span').textContent=o?'Show less':'Learn more'});
  });

  /* Testimonials: radios do the work; script adds swipe and keyboard */
  $$('[data-sg-carousel]:not([data-ready])').forEach(function(root){root.setAttribute('data-ready','');
    var radios=$$('.sg-t-radio',root),tr=$('.sg-track',root);if(!radios.length)return;
    function cur(){for(var i=0;i<radios.length;i++)if(radios[i].checked)return i;return 0}
    function go(i){var r=radios[(i+radios.length)%radios.length];r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}))}
    $$('.sg-controls label[role="button"]',root).forEach(function(l){l.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();l.click()}})});
    root.addEventListener('keydown',function(e){if(e.target.closest('input,textarea,select'))return;if(e.key==='ArrowRight'){go(cur()+1)}if(e.key==='ArrowLeft'){go(cur()-1)}});
    var x0=null,y0=null;
    tr.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY},{passive:true});
    tr.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))go(cur()+(dx<0?1:-1));x0=null},{passive:true});
  });

  /* See more: hide the link when the text already fits */
  function syncMore(){
    $$('.sg-more').forEach(function(l){var t=document.getElementById(l.getAttribute('for'));if(!t||t.checked)return;
      var box=l.previousElementSibling;if(!box)return;
      var wasHidden=box.offsetParent===null;if(wasHidden)return;
      l.classList.toggle('is-hidden',box.scrollHeight<=box.clientHeight+2);});
  }
  window.addEventListener('load',syncMore);window.addEventListener('resize',syncMore);
  document.addEventListener('change',function(e){if(e.target.classList&&e.target.classList.contains('sg-t-radio'))setTimeout(syncMore,30)});
  syncMore();

  /* Copy phone */
  $$('[data-sg-copy]:not([data-ready])').forEach(function(b){b.setAttribute('data-ready','');
    b.addEventListener('click',function(){var t=b.getAttribute('data-sg-copy');var done=function(){var o=b.textContent;b.textContent='Copied';setTimeout(function(){b.textContent=o},1600)};
      if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(t).then(done,function(){});});
  });

    /* Photo lightbox */
    $$('[data-sg-gallery]:not([data-ready])').forEach(function(root){root.setAttribute('data-ready','');
      var photos=$$('.sg-photo',root);if(!photos.length)return;
      var dlg=document.createElement('dialog');dlg.className='sg-lightbox';dlg.setAttribute('aria-label','Photo viewer');
      dlg.innerHTML='<button class="sg-lb-btn sg-lb-close" type="button" aria-label="Close"><svg width="14" height="14" viewBox="0 0 14 14" stroke="currentColor" stroke-width="1.6"><path d="M2 2l10 10M12 2 2 12"/></svg></button>'+
        '<button class="sg-lb-btn sg-lb-prev" type="button" aria-label="Previous photo"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M10 3 5 8l5 5"/></svg></button>'+
        '<button class="sg-lb-btn sg-lb-next" type="button" aria-label="Next photo"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="m6 3 5 5-5 5"/></svg></button>'+
        '<figure><img alt=""><figcaption></figcaption></figure>';
      document.body.appendChild(dlg);
      var img=$('img',dlg),cap=$('figcaption',dlg),idx=0,x0=null;
      function vis(){return photos.filter(function(p){return !p.hidden})}
      function show(i){var v=vis();idx=(i+v.length)%v.length;var p=v[idx],src=p.getAttribute('data-full')||$('img',p).currentSrc||$('img',p).src;img.src=src;img.alt=$('img',p).alt;cap.textContent=(idx+1)+' of '+v.length;}
      photos.forEach(function(p){p.addEventListener('click',function(){show(vis().indexOf(p));if(!dlg.open)dlg.showModal();});});
      $$('.sg-filter button',root).forEach(function(b){b.addEventListener('click',function(){var f=b.getAttribute('data-filter');
        $$('.sg-filter button',root).forEach(function(x){x.setAttribute('aria-pressed',String(x===b))});
        photos.forEach(function(p){p.hidden=!(f==='all'||p.getAttribute('data-cat')===f);if(!p.hidden&&!RM){p.classList.remove('in');void p.offsetWidth;p.classList.add('in');}});});});
      $('.sg-lb-close',dlg).addEventListener('click',function(){dlg.close()});
      $('.sg-lb-prev',dlg).addEventListener('click',function(){show(idx-1)});
      $('.sg-lb-next',dlg).addEventListener('click',function(){show(idx+1)});
      dlg.addEventListener('click',function(e){if(e.target===dlg||e.target.tagName==='FIGURE')dlg.close()});
      dlg.addEventListener('keydown',function(e){if(e.key==='ArrowRight')show(idx+1);if(e.key==='ArrowLeft')show(idx-1)});
      dlg.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
      dlg.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>50)show(idx+(dx<0?1:-1));x0=null});
    });
  }
  boot();
  document.addEventListener('shopify:section:load',boot);

  /* Desktop: service descriptions always open */
  var wide=window.matchMedia('(min-width: 821px)');
  function syncAcc(){$$('.sg-acc, .sg-desk-open').forEach(function(d){if(wide.matches)d.open=true;})}
  syncAcc();if(wide.addEventListener)wide.addEventListener('change',syncAcc);
  document.addEventListener('shopify:section:load',syncAcc);



  /* Reveal on scroll */
  if('IntersectionObserver' in window&&!RM){
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
    $$('.sg-reveal').forEach(function(el){var r=el.getBoundingClientRect();if(r.top>innerHeight)io.observe(el)});
  }
})();
